import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Preloader from '@omilia/preloader';

import {
  dictionariesEntry,
  dictionariesColumn,
  paginationOptionsType,
} from 'types';
import DictionariesEntriesTable from './components/DictionariesEntriesTable';
import './style.scss';

export class DictionariesEntries extends Component {
  static propTypes = {
    loadNextEntries: PropTypes.func.isRequired,
    removeRow: PropTypes.func.isRequired,
    saveEntry: PropTypes.func.isRequired,
    sortItems: PropTypes.func.isRequired,
    addNewColumn: PropTypes.func,
    addNewEntry: PropTypes.func,
    columns: PropTypes.arrayOf(dictionariesColumn),
    deleteColumn: PropTypes.func,
    entries: PropTypes.arrayOf(dictionariesEntry),
    entriesPagination: paginationOptionsType,
    isLoading: PropTypes.bool,
    isLoadingEntries: PropTypes.bool,
    selection: PropTypes.arrayOf(PropTypes.string),
    toggleAllSelection: PropTypes.func,
    toggleSelection: PropTypes.func,
    updateColumn: PropTypes.func,
  };

  static defaultProps = {
    entries: [],
  };

  renderPreloader() {
    const { isLoading, isLoadingEntries } = this.props;
    if (isLoading || isLoadingEntries) {
      return <Preloader data-test="loader-preloader" styleName="loader" />;
    }
    return null;
  }

  render() {
    const {
      entries,
      entriesPagination,
      columns,
      removeRow,
      loadNextEntries,
      isLoadingEntries,
    } = this.props;
    return (
      <div styleName="entries">
        {this.renderPreloader()}
        <DictionariesEntriesTable
          columns={columns}
          entries={entries}
          entriesPagination={entriesPagination}
          isLoadingEntries={isLoadingEntries}
          loadNextEntries={loadNextEntries}
          saveEntry={this.props.saveEntry}
          selection={this.props.selection}
          sortItems={this.props.sortItems}
          toggleAllSelection={this.props.toggleAllSelection}
          toggleSelection={this.props.toggleSelection}
          onDeleteColumn={this.props.deleteColumn}
          onRemoveRow={removeRow}
          onSaveColumnUpdate={this.props.updateColumn}
          onSaveNewColumn={this.props.addNewColumn}
          onSaveNewEntry={this.props.addNewEntry}
        />
      </div>
    );
  }
}

export default DictionariesEntries;
